// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload-btn[data-v-f8879a32]{display:inline-block;width:60px;height:60px;background:#fff;border:1px dashed #d2d2d2;font-size:36px;color:#bdbdbd;line-height:58px;text-align:center}", ""]);
// Exports
module.exports = exports;
